import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useUpdatePatientAdvisoryMutation } from "app/store/patient/api/patientApi";
import { toggleModal } from "app/store/patient/slice/patientSlice";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  PATIENT_BULK_UPDATE_FORM_LABEL_MAPPER,
  PATIENT_BULK_UPDATE_MODAL_TITLE,
} from "static/constants";
import { showErrorToast, showSuccessToast } from "utils/toast";

const useStyles = makeStyles({
  formContainer: { paddingTop: "15px" },
});

const PatientBulktUpdateModal = ({ modalType, leadModel }) => {
  const classes = useStyles();
  const { totalSelectedRows, selectedPatients } = useSelector(
    (state) => state.patient
  );
  const dispatch = useDispatch();
  const [status, setStatus] = useState("");

  const [updatePatientAdvisory, { isLoading }] =
    useUpdatePatientAdvisoryMutation();

  const title = PATIENT_BULK_UPDATE_MODAL_TITLE[modalType];
  const statusLabels = PATIENT_BULK_UPDATE_FORM_LABEL_MAPPER[modalType];

  const handleUpdate = async () => {
    try {
      const isActive = status === "active";

      const payload = {
        patientIds: selectedPatients,
        ...(modalType === "showDeviceAlertModal" && {
          deviceAlert: isActive,
        }),
        ...(modalType === "showAdvisoryModal" && {
          lead: {
            model: leadModel,
            advisory: isActive,
          },
        }),
      };

      const response = await updatePatientAdvisory(payload).unwrap();

      if (!response?.error) {
        showSuccessToast(response?.message);
        dispatch(toggleModal({ type: modalType, value: false }));
      }
    } catch (error) {
      showErrorToast(error?.message);
    }
  };

  return (
    <ModalWrapper
      show={modalType}
      showContentDivider
      title={`Are you sure you want to update ${title?.toLowerCase()} for ${totalSelectedRows} ${totalSelectedRows > 1 ? "records" : "record"} ?`}
      actionButtons={[
        {
          label: "Cancel",
          variant: "outlined",
          color: "secondary",
          onClick: () => {
            dispatch(toggleModal({ type: modalType, value: false }));
          },
        },
        {
          label: "Update",
          variant: "contained",
          color: "secondary",
          disabled: isLoading || status === "",
          onClick: () => handleUpdate(),
        },
      ]}
    >
      <FormControl className={classes.formContainer}>
        <FormLabel id="demo-radio-buttons-group-label">Select Status</FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          name="radio-buttons-group"
        >
          <FormControlLabel
            value="active"
            control={<Radio />}
            label={statusLabels?.active || "Active"}
          />
          <FormControlLabel
            value="inactive"
            control={<Radio />}
            label={statusLabels?.inactive || "Inactive"}
          />
        </RadioGroup>
      </FormControl>
    </ModalWrapper>
  );
};

export default PatientBulktUpdateModal;
